import axios from "axios";
import qs from "qs";
import store from "./store";
// import { Toast } from 'vant';
axios.defaults.baseURL = process.env.PROXY_API;
import Vue from "vue";
import { getServer } from '@/assets/js/tools';

const vueInstance = new Vue();
import {setCookie} from "./assets/js/tools";

axios.defaults.retry = 5; //重试次数
axios.defaults.timeout = 7000;

function getCurrentDomain() {
    var parts = window.location.hostname.split('.');
    var domain = parts.slice(-2).join('.');
    return '.' + domain;
}

export function updateAccessToken(needToken) {
    let login_token = $cookies.get("aiLoginToken");
    if (!login_token) {
        if (!needToken) {
            vueInstance.logOut();
        }
        return;
    }

    return axios.get(
        "/api/freshaccesstoken?login_token=" + login_token, {needToken: false}
    ).then(res => {
        let result = res.data;

        if (result.access_token) {
            let seconds = 60 * 60; //1小时
            let expires = new Date(new Date() * 1 + seconds * 1000);
            setCookie("aiAccessToken", result.access_token, 60 * 24 * 30);
            var dynamicDomain = getCurrentDomain();
            $cookies.set("aiAccessToken", result.access_token, 60 * 60 * 24 * 30, dynamicDomain);
            Vue.prototype.isToken();
            return result.access_token;
        } else {
            vueInstance.logOut();
            return false;
        }
    });
}

// 请求拦截
axios.interceptors.request.use(
    async config => {
        let c_loginToken = $cookies.get("aiLoginToken");
        let c_token = $cookies.get("aiAccessToken");

        if (c_loginToken) {
            store.commit("setToken", c_token);
            store.commit("setLoginToken", c_loginToken);
        }

        if (config.method === "post") {
            let qsData = qs.parse(config.data);
            if (qsData) {
                if (Object.prototype.toString.call(config.data) == "[object FormData]") {//文件上传的数据格式
                } else {
                    qsData.access_token = c_loginToken ? c_token : "";
                    config.data = qs.stringify(qsData);
                }
            } else {
                config.data = qs.stringify({access_token: c_loginToken ? c_token : ""});
            }
        } else if (config.method === "get") {
            if (config.params) {
                config.params.access_token = c_loginToken ? c_token : "";
            } else {
                config.params = {
                    access_token: c_loginToken ? c_token : ""
                };
            }
        }

        if (config.method === "get") {
            //get请求加时间戳，防止IE缓存
            config.params = {
                t: Date.parse(new Date()) / 1000,
                ...config.params
            };
        }

        if (!c_token && c_loginToken && config.url.indexOf("api/freshaccesstoken") == -1) {
            let access_token = await updateAccessToken(config.params.needToken);

            if (access_token) {
                //config携带的还是旧参数，换上新的access_token
                let qsData = qs.parse(config.data);
                qsData.access_token = access_token;

                if (config.method == "post") {
                    config.data = qs.stringify(qsData);
                } else {
                    if (config.params) {
                        config.params.access_token = qsData.access_token;
                    }
                }
            }

            return config;
        }

        if (process.env.NODE_ENV == "development") {
            console.log("请求：" + getServer() + config.url + "?" + qs.stringify(config.params) + (config.data ? "&" + config.data : ""));
        }

        return config;
    },
    error => {
        return Promise.reject(error);
    }
);


axios.interceptors.response.use(
    async response => {
        let result = response.data, config = response.config;

        // 判断是否配置了重试
        if (!config || !config.retry) return Promise.reject("重试次数未配置");

        // 设置重试次数，默认为0
        config.__retryCount = config.__retryCount || 0;

        // 判断是否超过了重试次数
        if (config.__retryCount >= config.retry) {
            return Promise.reject("超过重试次数");
        }

        //重试次数自增
        config.__retryCount += 1;

        if (result) {
            let params = config.data ? qs.parse(config.data) : config.params;
            if (result.errorno == 10001) {
                //需要去更新token 再重新请求
                let access_token = await updateAccessToken(params.needToken);
                config.baseURL = "";

                if (access_token) {
                    if (params) {
                        params.access_token = access_token;
                    }

                    return axios.request(config);
                }

            }

            if (result.errorno == 10002) {
                vueInstance.logOut();
                return;
            }
            if (result.error) {
                // Toast(result.error);
            }
        }

        return response;
    },
    error => {
        // if(error.errorno == 10002){
        //     vueInstance.unLoginHandle();
        //     return Promise.reject(error);
        // }

        // if(error.message.includes('timeout')){   // 判断请求异常信息中是否含有超时timeout字符串
        //   Toast('网络链接超时，请重试');
        //   return Promise.reject(error);
        // }
        return Promise.reject(error);
    }
);

export default axios;



// WEBPACK FOOTER //
// ./src/http.js